import { Paper } from "@material-ui/core";
import { blue, cyan, grey, orange, purple } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { sortBy } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashboardFilterState } from "src/types";

import { Dispatch, StoreState } from "../store";
import { dashboardFiltersPartiallyEqual, format } from "../utilities";
import PieChart from "./generic/PieChart";

const useStyles = makeStyles((theme) => ({
  paper: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
}));

const COLORS = [
  blue[500],
  blue[700],
  blue[900],
  grey[700],
  orange[500],
  cyan[300],
  cyan[900],
  purple[400],
  cyan[600],
  blue[300],
];

const keyLabelMapping = {
  countOnlyElectricity: "Stromkunden",
  countOnlyGas: "Gaskunden",
  countOnlyHeating: "Fernwärmekunden",
  countOnlyGlassFiber: "Glasfaserkunden",
  countOnlyElectricityAndGas: "Strom- und Gaskunden",
  countOnlyElectricityAndHeating: "Strom- und Fernwärmekunden",
  countOnlyElectricityAndGlassFiber: "Strom- und Glasfaserkunden",
  countOnlyGasAndHeating: "Gas- und Fernwärmekunden",
  countOnlyGasAndGlassFiber: "Gas- und Glasfaserkunden",
  countOnlyHeatingAndGlassFiber: "Fernwärme- und Glasfaserkunden",
  countOnlyElectricityGasAndHeating: "Strom-, Gas- und Fernwärmekunden",
  countOnlyElectricityGasAndGlassFiber: "Strom-, Gas- und Glasfaserkunden",
  countOnlyGasHeatingAndGlassFiber: "Gas-, Fernwärme- und Glasfaserkunden",
};

const PieChartsNbaAndCustomerSectors: React.FC = () => {
  const classes = useStyles();
  const [chartData, setChartData] = useState<
    Array<{ label: string; value: number }>
  >([]);
  const customerSectorsStatistics = useSelector(
    (state: StoreState) => state.customerSectorsStatistics
  );
  const dashboardFilter = useSelector(
    (state: StoreState) => state.dashboardFilter,
    (
      dashboardFilterOld: DashboardFilterState,
      dashboardFilterNew: DashboardFilterState
    ) =>
      dashboardFiltersPartiallyEqual(dashboardFilterOld, dashboardFilterNew, [
        "dateRange",
        "score",
      ])
  );
  const dispatch = useDispatch<Dispatch>();
  const [triggerSetChartData, setTriggerSetChartData] = useState(false);

  useEffect(() => {
    setChartData([]);
    setTriggerSetChartData(true);
    dispatch.customerSectorsStatistics.fetchCustomerSectorsStatistics(
      dashboardFilter
    );
  }, [dashboardFilter, dispatch]);

  useEffect(() => {
    if (triggerSetChartData && !customerSectorsStatistics.loading) {
      setChartData(
        sortBy(
          Object.keys(customerSectorsStatistics)
            .filter((key) => !["count", "loading", "pending"].includes(key))
            .map((key) => ({
              value:
                (customerSectorsStatistics[key] /
                  customerSectorsStatistics.count) *
                100,
              label: keyLabelMapping[key],
            })),
          (d) => d.value
        )
      );
      setTriggerSetChartData(false);
    }
  }, [customerSectorsStatistics, triggerSetChartData]);

  const dateLabel = format(new Date(), "MMMM yyyy");
  return (
    <Paper className={classes.paper}>
      <PieChart
        id="customer_sector_statistics_pie_chart"
        loading={customerSectorsStatistics.loading}
        title={`Kunden nach Sparte für ${dateLabel}`}
        data={chartData}
        colorScheme={COLORS}
        tooltipFormatter={(v) => `${v.toFixed(1)}%`}
        showTooltip
      />
    </Paper>
  );
};

export default PieChartsNbaAndCustomerSectors;



// WEBPACK FOOTER //
// ./src/components/PieChartCustomerSectorStatistics.tsx